import { useFlags } from "flagsmith/react";

export const useAppFlags = () => {
  const flags = useFlags(["is_disable_product_variant"]);
  return {
    isDisableProductVariant: flags.is_disable_product_variant.enabled,
  };
};
